import { Component, h, Host } from '@stencil/core';

@Component({
  tag: 'component-separator',
  styleUrl: 'component-separator.scss',
  shadow: true
})
export class ComponentSeparator {
  render() {
    return (
      <Host>
        <div class="seperator" />
      </Host>
    );
  }
}
